// src/components/HeroVisual.jsx

export default function HeroVisual({
  size = 240,
  color = "#4f46e5",
  variant = "final",
  src,             // προαιρετικό: δίνεις απευθείας διαδρομή εικόνας
}) {
  const svgSize = Math.min(Math.max(size, 96), 1024);
  const gradientId = `lg-${String(variant).replace(/[^a-z0-9]/gi, "")}`;
  const boxStyle = {
    width: svgSize,
    height: "auto",
    aspectRatio: "1 / 1",
    maxWidth: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  // --- ASSET VARIANT (final) ---
  if (variant === "final") {
    const srcPng = src || "/assets/orion-logo-800.png"; // αν δεν δώσεις src, ψάχνει αυτό
    const hasSvg = false; // κάν’ το true και βάλε /assets/orion-final.svg αν έχεις SVG
    const srcSvg = "/assets/orion-final.svg";

    return (
      <div style={boxStyle}>
        <img
          src={hasSvg ? srcSvg : srcPng}
          alt="Orion Intelligence logo"
          style={{
            maxWidth: "95%",
            maxHeight: "95%",
            objectFit: "contain",
            display: "block",
          }}
        />

      </div>
    );
  }

  // --- SVG VARIANTS ---
  const NegativeOI = () => (
    <svg width={svgSize} height={svgSize} viewBox="0 0 256 256" role="img">
      <title>Negative-space OI</title>
      <defs>
        <linearGradient id={gradientId} x1="0" x2="1">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor="#7A5CFF" />
        </linearGradient>
      </defs>
      <circle cx="128" cy="128" r="92" stroke={`url(#${gradientId})`} strokeWidth="10" fill="none" />
      <rect x="116" y="76" width="24" height="104" rx="6" fill={color} />
    </svg>
  );

  const ConstellationA = () => (
    <svg width={svgSize} height={svgSize} viewBox="0 0 256 256" role="img">
      <title>Orion monogram mark</title>
      <defs>
        <linearGradient id={gradientId} x1="0" x2="1">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor="#7A5CFF" />
        </linearGradient>
      </defs>
      <circle cx="128" cy="128" r="92" stroke={`url(#${gradientId})`} strokeWidth="10" fill="none" />
      <rect x="120" y="84" width="16" height="88" rx="4" fill={color} opacity="0.95" />
      <path d="M96 120 C108 92 140 88 156 108" fill="none" stroke={color} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" opacity="0.95" />
    </svg>
  );

  const ConstellationB = () => (
    <svg width={svgSize} height={svgSize} viewBox="0 0 256 256" role="img">
      <title>Orion network mark</title>
      <defs>
        <linearGradient id={gradientId} x1="0" x2="1">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor="#7A5CFF" />
        </linearGradient>
      </defs>
      <circle cx="128" cy="128" r="92" stroke={`url(#${gradientId})`} strokeWidth="10" fill="none" />
      <g stroke={color} strokeWidth="2" fill="none" strokeLinecap="round">
        <path d="M92 148 L112 124 L136 140 L160 112" />
        <path d="M112 124 L120 96 L144 108" />
      </g>
      <g fill={color}>
        <circle cx="92" cy="148" r="5" />
        <circle cx="112" cy="124" r="5" />
        <circle cx="136" cy="140" r="5" />
        <circle cx="160" cy="112" r="5" />
        <circle cx="120" cy="96" r="4.5" />
        <circle cx="144" cy="108" r="4.5" />
      </g>
    </svg>
  );

  const ConstellationC = () => (
    <svg width={svgSize} height={svgSize} viewBox="0 0 256 256" role="img">
      <title>Orion circuit mark</title>
      <defs>
        <linearGradient id={gradientId} x1="0" x2="1">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor="#7A5CFF" />
        </linearGradient>
      </defs>
      <circle cx="128" cy="128" r="92" stroke={`url(#${gradientId})`} strokeWidth="10" fill="none" />
      <g fill={color} opacity="0.9">
        <path d="M112 96 L140 100 L132 128 L104 120 Z" />
        <path d="M140 100 L168 120 L152 150 L132 128 Z" opacity="0.85" />
        <path d="M104 120 L132 128 L120 156 L92 148 Z" opacity="0.8" />
      </g>
      <g fill={color}>
        <circle cx="148" cy="116" r="3.5" />
        <circle cx="118" cy="140" r="3" />
      </g>
    </svg>
  );

  const ConstellationLetter = () => (
    <svg width={svgSize} height={svgSize} viewBox="0 0 256 256" role="img">
      <title>Constellation letter OI</title>
      <defs>
        <linearGradient id={gradientId} x1="0" x2="1">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor="#7A5CFF" />
        </linearGradient>
      </defs>
      <circle cx="128" cy="128" r="92" stroke={`url(#${gradientId})`} strokeWidth="10" fill="none" />
      <g stroke={color} strokeWidth="2" fill="none" strokeLinecap="round">
        <path d="M90 140 L110 120 L130 138" />
      </g>
      <g fill={color}>
        <circle cx="90" cy="140" r="5" />
        <circle cx="110" cy="120" r="5" />
        <circle cx="130" cy="138" r="5" />
        <circle cx="160" cy="88" r="5" />
        <circle cx="160" cy="168" r="5" />
      </g>
    </svg>
  );

  const OrbitI = () => (
    <svg width={svgSize} height={svgSize} viewBox="0 0 256 256" role="img">
      <title>Orbit I</title>
      <defs>
        <linearGradient id={gradientId} x1="0" x2="1">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor="#7A5CFF" />
        </linearGradient>
      </defs>
      <circle cx="128" cy="128" r="92" stroke={`url(#${gradientId})`} strokeWidth="8" fill="none" />
      <rect x="124" y="80" width="8" height="96" rx="3" fill={color} />
      <path d="M48 96 C120 56 136 200 208 160" stroke={color} strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.95" />
    </svg>
  );

  const OrbitalSVG = () => (
    <svg width={svgSize} height={svgSize} viewBox="0 0 256 256" role="img">
      <title>Orion orbital mark</title>
      <defs>
        <linearGradient id={gradientId} x1="0" x2="1">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor="#7A5CFF" />
        </linearGradient>
      </defs>
      <circle cx="128" cy="128" r="92" stroke={`url(#${gradientId})`} strokeWidth="10" fill="none" />
      <g stroke={color} strokeWidth="4" fill="none" strokeLinecap="round">
        <path d="M36 128a92 92 0 0 0 184 0" opacity="0.95" />
        <path d="M54 84a110 110 0 0 0 148 88" opacity="0.8" />
      </g>
      <circle cx="200" cy="96" r="6" fill={color} />
    </svg>
  );

  const MonogramSignal = () => (
    <svg width={svgSize} height={svgSize} viewBox="0 0 256 256" role="img">
      <title>Monogram with signal</title>
      <defs>
        <linearGradient id={gradientId} x1="0" x2="1">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor="#7A5CFF" />
        </linearGradient>
      </defs>
      <circle cx="128" cy="128" r="92" stroke={`url(#${gradientId})`} strokeWidth="10" fill="none" />
      <rect x="120" y="84" width="16" height="88" rx="4" fill={color} />
      <path d="M152 72 C168 88 176 112 176 128" stroke={color} strokeWidth="3" fill="none" opacity="0.9" />
    </svg>
  );

  const NetworkHybrid = () => (
    <svg width={svgSize} height={svgSize} viewBox="0 0 256 256" role="img">
      <title>Network hybrid</title>
      <defs>
        <linearGradient id={gradientId} x1="0" x2="1">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor="#7A5CFF" />
        </linearGradient>
      </defs>
      <circle cx="128" cy="128" r="92" stroke={`url(#${gradientId})`} strokeWidth="10" fill="none" />
      <g fill={color} opacity="0.95">
        <path d="M108 100 L132 108 L124 136 L100 128 Z" />
        <path d="M132 108 L156 124 L140 152 L124 136 Z" opacity="0.9" />
        <path d="M100 128 L124 136 L112 164 L88 156 Z" opacity="0.85" />
      </g>
    </svg>
  );

  const PixelTransition = () => (
    <svg width={svgSize} height={svgSize} viewBox="0 0 256 256" role="img">
      <title>Pixel to vector</title>
      <defs>
        <linearGradient id={gradientId} x1="0" x2="1">
          <stop offset="0%" stopColor={color} />
          <stop offset="100%" stopColor="#7A5CFF" />
        </linearGradient>
      </defs>
      <circle cx="176" cy="128" r="72" stroke={`url(#${gradientId})`} strokeWidth="8" fill="none" />
      <g fill={color}>
        <rect x="48" y="96" width="10" height="10" />
        <rect x="60" y="96" width="10" height="10" />
        <rect x="48" y="108" width="10" height="10" />
        <rect x="60" y="108" width="10" height="10" />
        <rect x="72" y="96" width="10" height="10" opacity="0.8" />
      </g>
      <rect x="140" y="96" width="16" height="88" rx="4" fill={color} />
    </svg>
  );

  // Επιλογή variant
  const v = variant || "negative-oi";
  const known = new Set([
    "negative-oi",
    "constellation-a",
    "constellation-b",
    "constellation-c",
    "constellation-letter",
    "orbit-i",
    "monogram-signal",
    "network-hybrid",
    "pixel-transition",
    "orbital",
  ]);

  return (
    <div role="img" aria-label={`Orion logo ${v}`} className="flex items-center justify-center" style={boxStyle}>
      {v === "negative-oi" && <NegativeOI />}
      {v === "constellation-a" && <ConstellationA />}
      {v === "constellation-b" && <ConstellationB />}
      {v === "constellation-c" && <ConstellationC />}
      {v === "constellation-letter" && <ConstellationLetter />}
      {v === "orbit-i" && <OrbitI />}
      {v === "monogram-signal" && <MonogramSignal />}
      {v === "network-hybrid" && <NetworkHybrid />}
      {v === "pixel-transition" && <PixelTransition />}
      {v === "orbital" && <OrbitalSVG />}

      {!known.has(v) && (
        <svg viewBox="0 0 120 120" width={svgSize} height={svgSize}>
          <defs>
            <linearGradient id="g" x1="0" x2="1">
              <stop offset="0" stopColor="#6b7280" />
              <stop offset="1" stopColor={color} />
            </linearGradient>
          </defs>
          <rect x="0" y="0" width="120" height="120" rx="18" fill="#0f172a" />
          <g transform="translate(20,20)">
            <circle cx="20" cy="20" r="18" fill="url(#g)" />
            <path d="M48 6 L72 36 L48 66 L24 36 Z" fill="#0b1220" opacity="0.6" />
            <text x="60" y="88" fontSize="12" fill="#cbd5e1" textAnchor="middle">ORION</text>
          </g>
        </svg>
      )}
    </div>
  );
}
